import { render, staticRenderFns } from "./edite-user.vue?vue&type=template&id=1b613672"
import script from "./edite-user.vue?vue&type=script&lang=js"
export * from "./edite-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports